import { __decorate, __extends } from "tslib";
import { upgradeProperty, FoundationProperty, coerceNumber, coerceBoolean } from '@tyler-components-web/core';
import { LIST_DROPDOWN_CONSTANTS } from './list-dropdown-constants';
var ListDropdownAware = /** @class */ (function (_super) {
    __extends(ListDropdownAware, _super);
    function ListDropdownAware() {
        return _super.call(this) || this;
    }
    ListDropdownAware.prototype.initializedCallback = function () {
        upgradeProperty(this, 'popupClasses');
        upgradeProperty(this, 'popupHeaderBuilder');
        upgradeProperty(this, 'popupFooterBuilder');
        upgradeProperty(this, 'syncPopupWidth');
        upgradeProperty(this, 'optionLimit');
        upgradeProperty(this, 'observeScroll');
        upgradeProperty(this, 'observeScrollThreshold');
        upgradeProperty(this, 'highlightFirst');
    };
    ListDropdownAware.prototype.attributeChangedCallback = function (name, oldValue, newValue) {
        switch (name) {
            case LIST_DROPDOWN_CONSTANTS.attributes.HIGHLIGHT_FIRST:
                this.highlightFirst = coerceBoolean(newValue);
                break;
            case LIST_DROPDOWN_CONSTANTS.attributes.POPUP_CLASSES:
                this.popupClasses = newValue;
                break;
            case LIST_DROPDOWN_CONSTANTS.attributes.OPTION_LIMIT:
                this.optionLimit = coerceNumber(newValue);
                break;
            case LIST_DROPDOWN_CONSTANTS.attributes.OBSERVE_SCROLL:
                this.observeScroll = this.hasAttribute(LIST_DROPDOWN_CONSTANTS.attributes.OBSERVE_SCROLL);
                break;
            case LIST_DROPDOWN_CONSTANTS.attributes.OBSERVE_SCROLL_THRESHOLD:
                this.observeScrollThreshold = coerceNumber(newValue);
                break;
            case LIST_DROPDOWN_CONSTANTS.attributes.SYNC_POPUP_WIDTH:
                this.syncPopupWidth = this.hasAttribute(LIST_DROPDOWN_CONSTANTS.attributes.SYNC_POPUP_WIDTH);
                break;
        }
    };
    __decorate([
        FoundationProperty()
    ], ListDropdownAware.prototype, "popupClasses", void 0);
    __decorate([
        FoundationProperty({ get: false })
    ], ListDropdownAware.prototype, "popupHeaderBuilder", void 0);
    __decorate([
        FoundationProperty({ get: false })
    ], ListDropdownAware.prototype, "popupFooterBuilder", void 0);
    __decorate([
        FoundationProperty()
    ], ListDropdownAware.prototype, "syncPopupWidth", void 0);
    __decorate([
        FoundationProperty()
    ], ListDropdownAware.prototype, "optionLimit", void 0);
    __decorate([
        FoundationProperty()
    ], ListDropdownAware.prototype, "observeScroll", void 0);
    __decorate([
        FoundationProperty()
    ], ListDropdownAware.prototype, "observeScrollThreshold", void 0);
    __decorate([
        FoundationProperty()
    ], ListDropdownAware.prototype, "highlightFirst", void 0);
    return ListDropdownAware;
}(HTMLElement));
export { ListDropdownAware };
